import { FC, FormEvent, ReactElement } from 'react'

import { FormActionButtons } from '@/compositions/@buttons/FormActionButtons/FormActionButtons'
import { ModalContent } from '@/compositions/ModalContent/ModalContent'
import { PacoModal } from '@/compositions/PacoModal/PacoModal'

import './ConfirmModal.scss'

interface ConfirmModalProps {
    title: string
    message: string
    confirmText: string
    cancelText?: string
    onConfirm: (event: FormEvent) => void
    onCancel: () => void
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
}): ReactElement => {
    const handleSubmit = (event: FormEvent): void => {
        event.preventDefault()
        onConfirm(event)
    }

    return (
        <PacoModal cardClassName="confirm-modal">
            <ModalContent title={title} contentWrapperClassName="confirm-modal__content-wrapper">
                <form onSubmit={handleSubmit}>
                    <p className="confirm-modal__message">{message}</p>
                    <FormActionButtons
                        cancelText={cancelText}
                        submitText={confirmText}
                        onCancelClick={onCancel}
                        className="confirm-modal__form-action-buttons"
                        submitButtonClassName="confirm-modal__submit-button"
                    />
                </form>
            </ModalContent>
        </PacoModal>
    )
}
